module.exports = __webpack_public_path__ + "media/images/vp/icon.switcher.off-e30dc6717fa242129615196e8af0aa17.png";